module.exports = __webpack_public_path__ + "img/airelibre.8871b8a5.png";